import cn from "classnames";
import * as React from "react";

type Props = {
  children?: React.ReactNode;
  className?: string;
  backgroundURL?: string;
};

const CardHeader: React.FC<Props> = ({
  className,
  children,
  backgroundURL = "",
}) => {
  const classes = cn("card-header", className);

  return (
    <div
      className={classes}
      style={
        backgroundURL
          ? {
              backgroundImage: `url(${backgroundURL})`,
            }
          : undefined
      }
    >
      {children}
    </div>
  );
};

export default CardHeader;
